<template>
  <div>
    <v-form ref="finalForm" v-model="valid" lazy-validation>
      <div>
        <v-card id="pass70" class="ep-rechner-box">
          <v-col cols="12" class="p-0">
            <div class="v-card__title p-0">
              <h2 class="v-card--head--title">{{ FinalTile5 }}</h2>
            </div>
          </v-col>

          <v-card-text>
            <v-row>
              <v-col cols="12">
                <div class="v-card--msg">
                  <h2 class="ep-rechner-h2">
                    {{ FinalTile6 }}
                  </h2>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="6" class="noshadow">
                <contract-dialog></contract-dialog>
              </v-col>
              <v-col cols="12" sm="6" class="noshadow">
                <inserted-data-dialog></inserted-data-dialog>
              </v-col>
            </v-row>
            <v-row
              v-if="selectedCase.valN == 4 || (selectedCase.valN == 7 && showStrCB)"
              class="tooltipbox-final"
            >
              <v-col cols="12">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      x-small
                      color="#022c54"
                      fab
                      dark
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark> mdi-help </v-icon>
                    </v-btn>
                  </template>
                  <span v-html="FinalTile7c"></span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                v-if="selectedCase.valN == 4 || (selectedCase.valN == 7 && showStrCB)"
                cols="12"
              >
                <v-checkbox v-model="epsv" :label="FinalTile7b"></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-checkbox
                  required
                  v-model="va"
                  :label="FinalTile7"
                ></v-checkbox>
              </v-col>
              <v-col cols="12">
                <v-checkbox v-model="agb" required
                  ><template v-slot:label>
                    <div v-if="contractLang == 'en'">
                      I have read Refund Pilot's
                      <a
                        href="https://www.ersatz-pilot.de/agb"
                        target="_blank"
                        @click.stop
                        v-on="on"
                        ><b>terms and conditions</b></a
                      >,
                      <a
                        href="https://www.ersatz-pilot.de/agb"
                        target="_blank"
                        @click.stop
                        v-on="on"
                        ><b>cancellation policy</b></a
                      >
                      and
                      <a
                        href="https://www.ersatz-pilot.de/datenschutzbestimmungen"
                        target="_blank"
                        @click.stop
                        v-on="on"
                        ><b>data protection policy</b></a
                      >
                      and agree with the terms and conditions and the processing
                      of my data under the data protection policy.
                    </div>
                    <div v-else>
                      Ich habe die
                      <a
                        href="https://www.ersatz-pilot.de/agb"
                        target="_blank"
                        @click.stop
                        v-on="on"
                        ><b>AGB</b></a
                      >, die
                      <a
                        href="https://www.ersatz-pilot.de/agb"
                        target="_blank"
                        @click.stop
                        v-on="on"
                        ><b>Widerrufsbelehrung</b></a
                      >
                      und die
                      <a
                        href="https://www.ersatz-pilot.de/datenschutzbestimmungen"
                        target="_blank"
                        @click.stop
                        v-on="on"
                        ><b>Datenschutzbestimmungen</b></a
                      >
                      von Ersatz-Pilot zur Kenntnis genommen und bin mit AGB und
                      Datenschutzbestimmungen einverstanden.
                    </div>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-row>
              <v-col cols="12">
                <v-btn
                  :loading="loading"
                  block
                  class="btn-ep-next-step"
                  :disabled="agb == false || va == false || noChange"
                  @click="check70"
                  >{{ FinalTile10 }}</v-btn
                >
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </div></v-form
    >
    <v-card v-if="success" class="ep-rechner-box">
      <v-col cols="12" class="p-0">
        <div class="v-card__title p-0">
          <h2
            class="v-card--head--title"
            style="background-color: var(--ep-green)"
          >
            {{ selectedLang.FinalTile11 }}
          </h2>
        </div>
      </v-col>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <div class="v-card--msg">
              <h2 class="ep-rechner-h2">
                <strong>{{ selectedLang.FinalTile13 }}</strong
                ><br />{{ FinalTile14 }}<br />{{ selectedLang.FinalTile15 }}
              </h2>
            </div>
          </v-col>
        </v-row>

        <v-row class="justify-center">
          <v-col cols="12" sm="6">
            <v-btn block color="" class="btn-ep-next-step" @click="restart()">{{
              selectedLang.FinalTile16
            }}</v-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-col cols="12">
          <v-btn id="" block class="btn-ep-back-to" @click="gotoEP()">{{
            selectedLang.FinalTile17
          }}</v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ContractDialog from "./FinalDialogs/ContractDialog.vue";
import InsertedDataDialog from "./FinalDialogs/InsertedDataDialog.vue";
import axios from "axios";
export default {
  name: "ResultTile",
  components: {
    ContractDialog,
    InsertedDataDialog,
  },
  data: function () {
    return {
      agb: false,
      va: false,
      epsv: false,
      success: false,
      FinalTile5: "",
      FinalTile6: "",
      FinalTile7: "",
      FinalTile7c: "",
      FinalTile10: "",
      FinalTile14: "",
      loading: false,
    };
  },
  mounted: function () {
    this.FinalTile7 = this.selectedLang.FinalTile7a;
    if (this.kiofCla == "TRF") {
      this.FinalTile5 = this.selectedLang.FinalTile5a;
      this.FinalTile6 = this.formatDBText(this.selectedLang.FinalTile6a, {
        "dataEP.anspr": this.dataEP.anspr,
      });
      this.FinalTile7b = this.selectedLang.FinalTile7b;
      this.FinalTile7c = this.selectedLang.FinalTile7c;
      this.FinalTile10 = this.selectedLang.FinalTile10a;
      this.FinalTile14 = this.selectedLang.FinalTile14a;
    } else if (this.kiofCla == "TRFDB") {
      this.FinalTile5 = this.selectedLang.FinalTile5a;
      this.FinalTile6 = this.formatDBText(this.selectedLang.FinalTile6aDB, {
        "dataEP.anspr": this.dataEP.anspr,
      });
      this.FinalTile7b = this.selectedLang.FinalTile7bDB;
      this.FinalTile7c = this.selectedLang.FinalTile7cDB;
      this.FinalTile10 = this.selectedLang.FinalTile10a;
      this.FinalTile14 = this.selectedLang.FinalTile14a;
    } else {
      this.FinalTile5 = this.selectedLang.FinalTile5;
      this.FinalTile6 = this.formatDBText(this.selectedLang.FinalTile6, {
        "dataEP.anspr": this.dataEP.anspr,
      });
      this.FinalTile7 = this.selectedLang.FinalTile7;
      this.FinalTile10 = this.selectedLang.FinalTile10;
      this.FinalTile14 = this.selectedLang.FinalTile14;
    }
  },
  computed: {
    ...mapState([
      "selectedDiv",
      "kiofCla",
      "dataEP",
      "pass70",
      "dataFS",
      "dataFSAN",
      "dataFSZB",
      "dataTrain",
      "user",
      "noChange",
      "selectedLang",
      "contractLang",
      "finalFormData",
      "selectedCase",
      "showStrCB"
    ]),
  },
  methods: {
    ...mapActions(["setVar", "killRun"]),
    check70() {
      if (this.$refs.finalForm.validate()) {
        this.loading = true;
        this.setVar({ pos: "pass70", val: true });
        this.dataEP.cancellationBEP = this.epsv;
        this.finalFormData.set(
          "caData",
          JSON.stringify({
            dataEP: this.dataEP,
            dataFS: this.dataFS,
            dataFSAN: this.dataFSAN,
            dataFSZB: this.dataFSZB,
            dataTrain: this.dataTrain,
            user: this.user,
            lang: this.contractLang,
            kiofCla: this.kiofCla,
          })
        );
        axios
          .post(
            "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/sendMailDSN.php",
            this.finalFormData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          )
          .then((response) => {
            if (response.status == "200") {
              this.success = true;
            }
            this.loading = false;
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => (this.loading = false));
      }
      this.setVar({ pos: "noChange", val: true });
      this.$gtag.event("9. Antrag abgeschickt", {
        event_category: "Rechner",
        event_label: "9. Antrag abgeschickt",
      });
    },

    gotoEP() {
      window.open("https://www.ersatz-pilot.de");
    },
    formatDBText(str, values) {
      var result;
      var reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    restart() {
      this.killRun({ vm: this });
    },
  },
};
</script>
